import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["data-position"]
const _hoisted_3 = { class: "product-price-card__body" }
const _hoisted_4 = { class: "fa-ul" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "fa-li" }
const _hoisted_7 = { class: "savings" }
const _hoisted_8 = { class: "fa-li" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "product-price-card__prices" }

import {
  computed,
  PropType,
  ref,
} from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { useRoute } from 'vue-router';
import Tooltip from '@/components/Tooltip.vue';
import Expand from '@/components/Expand.vue';
import PriceDetailsTable from '@/components/product/PriceDetailsTable.vue';
import { getRandomId } from '@/utils/BaseHelper';
import { Product } from '@/classes';

import PriceCalculation from '@/components/product/card/PriceCalculation.vue';
import { formatNumber } from '@/helpers';
import Savings from '@/components/product/card/Savings.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceCard',
  props: {
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  recommended: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  position: {
    type: Number,
  },
  isSingle: {
    type: Boolean,
    required: false,
    default: () => false,
  },
},
  emits: ['order', 'cart'],
  setup(__props, { emit: __emit }) {

library.add(faCheck);
library.add(faCircleInfo);

const emit = __emit;
const props = __props;

const route = useRoute();
const routeQueryVars = computed(() => route.query);
const productIds = Array.isArray(routeQueryVars.value.pid)
  ? routeQueryVars.value.pid.join(',')
  : routeQueryVars.value.pid ?? '';

const productToUse = ref<Product>(props.product);
const cardKey = ref(getRandomId());

const isDynamic = productToUse.value.price?.tariffType === 'dynamicSimple';
const isBusiness = props.product.priceCustomerType === 'business';

const submitDynamicTariff = computed(() => {
  const currentId = String(productToUse.value.attributes.id);

  return (
    isDynamic
      && !productIds
        .split(',')
        .map((id) => id.trim())
        .includes(currentId)
  );
});

const { price } = productToUse.value;

const fixedBonus = productToUse.value.getSummedBonus('fixed');
const fixedBonusValue = fixedBonus?.valueGrossFormatted;

const hasSavings = isBusiness
  ? (price?.mapped.active.savingsYearly ?? 0) > 0
  : (price?.mapped.active.savingsYearlyGross ?? 0) > 0;

const savingsValue = formatNumber(
  isBusiness
    ? (price?.mapped.active.savingsYearly ?? 0)
    : (price?.mapped.active.savingsYearlyGross ?? 0),
  2,
);

const emitCart = () => {
  emit('cart', productToUse.value);
};

return (_ctx: any,_cache: any) => {
  const _component_BaseEqualizerElementPart = _resolveComponent("BaseEqualizerElementPart")!
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-price-card-wrapper", { 'has-recommendation': productToUse.value.getRecommendationText(__props.isSingle) || _unref(fixedBonus) }])
  }, [
    (productToUse.value.getRecommendationText(__props.isSingle) || _unref(fixedBonus))
      ? (_openBlock(), _createBlock(_component_BaseEqualizerElementPart, {
          key: 0,
          name: "product-price-card-recommendation",
          class: "equalizer-recommendation"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "product-price-card-recommendation",
              innerHTML: productToUse.value.getRecommendationText(__props.isSingle) || `${_unref(fixedBonusValue)} € Bonus¹`
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["product-price-card", { recommended: __props.recommended }]),
      "data-position": __props.position
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BaseEqualizerElementPart, {
          class: _normalizeClass(["product-price-card__title", {'has-slogan': productToUse.value.attributes.slogan}]),
          name: "product-price-card-title",
          innerHTML: productToUse.value.name
        }, null, 8, ["class", "innerHTML"]),
        (productToUse.value.attributes.slogan)
          ? (_openBlock(), _createBlock(_component_BaseEqualizerElementPart, {
              key: 0,
              class: "product-price-card__slogan",
              name: "product-price-card-slogan",
              innerHTML: productToUse.value.attributes.slogan
            }, null, 8, ["innerHTML"]))
          : _createCommentVNode("", true),
        _createVNode(_component_BaseSpacer),
        _createVNode(_component_BaseEqualizerElementPart, {
          class: "product-price-card__benefits",
          name: "product-price-card-benefits"
        }, {
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_4, [
              (_unref(hasSavings))
                ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: "fa-regular fa-check" })
                    ]),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(savingsValue)) + " € Ersparnis im 1. Jahr ", 1),
                    _createVNode(Tooltip, null, {
                      title: _withCtx(() => [
                        (_openBlock(), _createBlock(Savings, {
                          product: productToUse.value,
                          key: `details-${cardKey.value}`
                        }, null, 8, ["product"]))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(FontAwesomeIcon), {
                          icon: "fa-solid fa-circle-info",
                          class: "text-primary"
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productToUse.value.benefits, (benefit, binx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `${productToUse.value.id}-benefit-${binx}`
                }, [
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_unref(FontAwesomeIcon), { icon: "fa-regular fa-check" })
                  ]),
                  _createElementVNode("span", { innerHTML: benefit }, null, 8, _hoisted_9)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_BaseSpacer, { size: "small" }),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["product-price-card__yearly text-center", { hiddenYearly: productToUse.value.price?.tariffType === 'dynamicSimple' }]),
            key: `yearly-${cardKey.value}`
          }, [
            _createTextVNode(_toDisplayString(productToUse.value.getPriceFormatted('yearly')) + " € ", 1),
            _cache[0] || (_cache[0] = _createElementVNode("span", null, " pro Jahr ", -1))
          ], 2)),
          (_openBlock(), _createElementBlock("div", {
            class: "product-price-card__monthly text-center",
            key: `monthly-${cardKey.value}`
          }, [
            _createTextVNode(_toDisplayString(_unref(formatNumber)(productToUse.value.getPriceValue('monthly'), 2)) + " € ", 1),
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(productToUse.value.price?.tariffType === 'dynamicSimple' ? 'Kosten im ersten Monat' : 'Kosten pro Monat') + " ", 1),
              (productToUse.value.price?.tariffType !== 'dynamicSimple')
                ? (_openBlock(), _createBlock(Tooltip, { key: 0 }, {
                    title: _withCtx(() => [
                      (_openBlock(), _createBlock(PriceCalculation, {
                        product: productToUse.value,
                        key: `details-${cardKey.value}`
                      }, null, 8, ["product"]))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(FontAwesomeIcon), {
                        icon: "fa-solid fa-circle-info",
                        class: "text-primary"
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]))
        ]),
        _createVNode(_component_BaseSpacer),
        _createVNode(Expand, {
          "font-size": "small",
          "button-class": "justify-content-start"
        }, {
          title: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("Preisdetails", -1)
          ]))]),
          default: _withCtx(() => [
            (_openBlock(), _createBlock(PriceDetailsTable, {
              product: productToUse.value,
              key: `details-${cardKey.value}`
            }, null, 8, ["product"]))
          ]),
          _: 1
        }),
        _createVNode(_component_BaseSpacer),
        (submitDynamicTariff.value)
          ? (_openBlock(), _createBlock(_component_BaseButton, {
              key: 1,
              "text-align": "center",
              width: "full",
              "link-type": "url",
              url: "https://www.stadtwerk-am-see.de/flexstrom"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Mehr Informationen ", -1)
              ]))]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_BaseButton, {
              key: 2,
              "text-align": "center",
              width: "full",
              "link-type": "button",
              onClick: emitCart
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Jetzt bestellen ", -1)
              ]))]),
              _: 1
            }))
      ])
    ], 10, _hoisted_2)
  ], 2))
}
}

})